import * as React from 'react';
import MobileSuiteHeader from "../../containers/MobileSuiteHeader";

// Gui Header for the mobile solution
const MobileSolutionHeaderLayout = () => (
    <div className="mobileSolutionHeader">
        <div>
          <MobileSuiteHeader />
        </div>
    </div>
)

export default MobileSolutionHeaderLayout;
